export enum SeatType {
  View = 'view',
  SchematicDiagramDesign = 'schematicDiagramDesign',
}

export enum OrgAccountSeatType {
  Normal = 'normal',
  Preempt = 'preempt',
}

export enum SeatVersion {
  Free = 'free',
  Pro = 'pro',
  CoCreation = 'co_creation',
}

export interface EmployeeSeat {
  avatar: string
  email: string
  employeeId: number
  employeeName: string
  seatType: SeatType
  onlineSeat: boolean
  organizationAccountSeatType: OrgAccountSeatType
}

export interface OrgSeat {
  id: number
  onlineSchematicDiagramDesignSeatAssignedQuantity: number
  onlineSchematicDiagramDesignSeatQuantity: number
  organizationId: number
  organizationMemberQuantity: number
  organizationAccountSeatType: OrgAccountSeatType
  schematicDiagramDesignSeatQuantity: number
  schematicDiagramDesignSeatAssignedQuantity: number
  designSeatAssignedQuantity: number
  seatType: SeatType
  seatTypeValue: string
  seatVersion: SeatVersion
  seatVersionValue: string
  validityPeriodBegin: string
  validityPeriodEnd: string
}
